import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './ToggleButton.css';

const ToggleButton = ({ text = '', open = false, containerStyle = {}, onClick = () => {} }) => {
    return (
        <button
            className={`${css.container} ${open ? css.opened : ''}`}
            onClick={onClick}
            style={{
                ...containerStyle,
            }}
        >
            <div className={css.buttonInner}>
                <Translate id={text} />
            </div>
        </button>
    );
};

ToggleButton.propTypes = {
    text: PropTypes.string,
    open: PropTypes.bool,
    onClick: PropTypes.func,
    containerStyle: PropTypes.objectOf(PropTypes.any),
};

export default ToggleButton;
